/**
 * Format milliseconds into MM:SS or HH:MM:SS
 */
export function formatTime(ms) {
  if (ms < 0) ms = 0;
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n) => String(n).padStart(2, '0');

  if (hours > 0) {
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }
  return `${pad(minutes)}:${pad(seconds)}`;
}

/**
 * Format minutes into human-readable string
 */
export function formatMinutes(minutes) {
  if (minutes < 60) return `${minutes}m`;
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return mins > 0 ? `${hrs}h ${mins}m` : `${hrs}h`;
}

/**
 * Get today's date as YYYY-MM-DD
 */
export function getToday() {
  return new Date().toISOString().split('T')[0];
}

/**
 * Get date N days ago as YYYY-MM-DD
 */
export function getDaysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().split('T')[0];
}

/**
 * Get the current year-month as YYYY-MM
 */
export function getCurrentMonth() {
  return new Date().toISOString().slice(0, 7);
}

/**
 * Check if two date strings represent consecutive days
 */
export function isConsecutiveDay(dateA, dateB) {
  const a = new Date(dateA);
  const b = new Date(dateB);
  const diffMs = Math.abs(a - b);
  const diffDays = Math.round(diffMs / (1000 * 60 * 60 * 24));
  return diffDays === 1;
}

/**
 * Generate a unique ID
 */
export function generateId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

/**
 * Timer presets
 */
export const TIMER_PRESETS = [
  { id: 'quick', label: 'Quick Focus', minutes: 15, icon: '⚡' },
  { id: 'pomodoro', label: 'Pomodoro', minutes: 25, icon: '🍅' },
  { id: 'deep', label: 'Deep Work', minutes: 50, icon: '🎯' },
  { id: 'marathon', label: 'Marathon', minutes: 90, icon: '🏔' },
];

/**
 * Focus tags/categories
 */
export const FOCUS_TAGS = [
  { id: 'work', label: 'Work', color: '#42a5f5' },
  { id: 'study', label: 'Study', color: '#ab47bc' },
  { id: 'reading', label: 'Reading', color: '#ff7043' },
  { id: 'creative', label: 'Creative', color: '#ffa726' },
  { id: 'exercise', label: 'Exercise', color: '#66bb6a' },
  { id: 'personal', label: 'Personal', color: '#26c6da' },
];
